import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Amplify } from "aws-amplify";
import { MemoryStorageNew } from "./util/MemoryStorageNew";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
// import * as Sentry from '@sentry/react';

import "mapbox-gl/dist/mapbox-gl.css";

import "/node_modules/react-grid-layout/css/styles.css";
import "/node_modules/react-resizable/css/styles.css";
import { BrowserRouter } from "react-router-dom";

// Sentry.init({
//   dsn: "https://6bc4438f4b208f55a2c1cf0a022d6378@o4506523161001984.ingest.sentry.io/4506534446039040",
//   integrations: [
//     new Sentry.BrowserTracing({
//       // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//       tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
//     }),
//     new Sentry.Replay({
//       maskAllText: false,
//       blockAllMedia: false,
//     }),
//   ],
//   // Performance Monitoring
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });

Amplify.configure({
  Auth: {
    // REQUIRED - Amazon Cognito Region
    region: process.env.REACT_APP_ENV === "PROD" ? "us-east-2" : "us-west-1",
    identityPoolId: process.env.REACT_APP_ENV === "PROD" ? "us-east-2:a4737708-73d0-420b-ae0d-9359313fa265" : "us-west-1:aead38f5-7336-4f51-ac29-9f702f317bfd",

    // OPTIONAL - Amazon Cognito Federated Identity Pool Region
    // Required only if it's different from Amazon Cognito Region

    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: process.env.REACT_APP_ENV === "PROD" ? "us-east-2_L0haUXuuL" : "us-east-2_xu8sAOglP",

    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: process.env.REACT_APP_ENV === "PROD" ? "641hadqabcgbpcgccls5mlmv45" : "2eaqbo6lv8sm686v0hd49chkfl",

    // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
    mandatorySignIn: false,

    // OPTIONAL - This is used when autoSignIn is enabled for Auth.signUp
    // 'code' is used for Auth.confirmSignUp, 'link' is used for email link verification
    signUpVerificationMethod: "code", // 'code' | 'link'

    // OPTIONAL - Configuration for cookie storage
    // Note: if the secure flag is set to true, then the cookie transmission requires a secure protocol

    // OPTIONAL - customized storage object

    // OPTIONAL - Manually set the authentication flow type. Default is 'USER_SRP_AUTH'

    // OPTIONAL - Manually set key value pairs that can be passed to Cognito Lambda Triggers

    // OPTIONAL - Hosted UI configuration
    oauth: {},
    storage: MemoryStorageNew,
  },

  // aws_appsync_graphqlEndpoint:
  //   "https://encdl52ro5dw3dgfemt3xqb2zi.appsync-api.us-east-2.amazonaws.com/graphql",
  aws_appsync_graphqlEndpoint: process.env.REACT_APP_ENV === "PROD" ? "https://encdl52ro5dw3dgfemt3xqb2zi.appsync-api.us-east-2.amazonaws.com/graphql" : "https://2swtjoy5x5cpzaxyhysztirjoe.appsync-api.us-west-1.amazonaws.com/graphql",
  aws_appsync_region: process.env.REACT_APP_ENV === "PROD" ? "us-east-2" : "us-west-1",
  aws_appsync_authenticationType: "API_KEY",
  // aws_appsync_apiKey: "da2-7kcgqx6yo5bhjj76bdrargvoqu",
  aws_appsync_apiKey: process.env.REACT_APP_ENV === "PROD" ? "da2-7kcgqx6yo5bhjj76bdrargvoqu" : "da2-bvxvm3ijqndwhd6o2yxvyhkp3u",
});

// async function initializeApp() {
//   try {
//     serviceWorkerRegistration.register();
//     ReactDOM.render(
//       <React.StrictMode>
//         <App />
//       </React.StrictMode>,
//       document.getElementById("root")
//     );
//   } catch (error) {
//     console.error("Error initializing app:", error);
//   }
// }

// initializeApp();
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
console.log("registerng service worker");
serviceWorkerRegistration.register();


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
